import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import logo from './images/circet_logo.png';
import 'bootstrap/js/dist/dropdown';
import NmaasHome from './NmaasHome';
import Events from './Events';
import UserRegistration from './components/UserRegistration';
import AddUpcomingEvents from './components/AddUpcomingEvents';
import UserMarketControl from './components/UserMarketControl';
import ChangePasswordModal from './components/ChangePasswordModal';
import { SIDEMENU_SUB } from './constant';
import AboutUs from './AboutUs';
import FIFA26 from './FIFA26';
import { logout as authLogout, isAccessTokenValid } from './auth';
import './styles/_home.scss';

export default function Home() {
  const [page, setPage] = useState<string>('Home');
  const [showChangePassword, setShowChangePassword] = useState(false);
  const navigate = useNavigate();

  const userName = localStorage.getItem('userName');
  const role = localStorage.getItem('role');

  useEffect(() => {
    if (!isAccessTokenValid()) {
      authLogout();
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  const logout = () => {
    authLogout();
    navigate('/login');
  };

  const changePage = (tab: string) => {
    if(tab === 'Admin'){
      return
    }else{
      setPage(tab);
    }
  };

  return (
    <div className="container-fluid p-0">
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-3">
        <a className="navbar-brand" href="#">
          <img src={logo} alt="Logo" height="40" />
        </a>
        <div className="navbar-nav me-auto">
          <a className={`nav-link ${page === 'Home' ? 'active' : ''}`} href="#" onClick={() => changePage('Home')}>Home</a>
          <a className={`nav-link ${page === 'Events' ? 'active' : ''}`} href="#" onClick={() => changePage('Events')}>Events</a>
          <a 
            className={`nav-link fifa26-new-tab ${page === 'FIFA26' ? 'active' : ''}`} 
            href="#" 
            onClick={() => changePage('FIFA26')}
          >
            🏆 FIFA26
            <span className="new-badge">NEW</span>
          </a>
          <a className={`nav-link ${page === 'About Us' ? 'active' : ''}`}href="#"  onClick={() => changePage('About Us')}>About Us</a>
          {role === 'admin' && (
            <div className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">Admin</a>
              <ul className="dropdown-menu">
                {SIDEMENU_SUB.map((subKey, subInd) => (
                  <li key={subInd}>
                    <a className="dropdown-item" onClick={() => changePage(subKey)}>{subKey}</a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="dropdown">
          <a
            className="nav-link dropdown-toggle text-white"
            href="#"
            id="userDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="bi bi-person-circle"></i> {userName}
          </a>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
            <li>
              <button className="dropdown-item" onClick={() => setShowChangePassword(true)}>
                Change Password
              </button>
            </li>
            <li>
              <button className="dropdown-item" onClick={logout}>
                Logout
              </button>
            </li>
          </ul>
        </div>
      </nav>

      <ChangePasswordModal
        show={showChangePassword}
        onHide={() => setShowChangePassword(false)}
      />

      <div className="container-fluid p-0 m-0 forms-container">
        {page === 'Home' && <NmaasHome />}
        {page === 'Events' && <Events />}
        {page === 'FIFA26' && <FIFA26 />}
        {page === 'User Registration' && <UserRegistration />}
        {page === 'Add Upcoming Events' && <AddUpcomingEvents />}
        {page === 'User Market Control' && <UserMarketControl />}
        {page === 'About Us' && <AboutUs />}
      </div>
    </div>
  );
}
